import { ReactNode } from 'react'

import { IconWrapper } from 'shared/atoms'

type DashboardCardHeaderProps = {
	icon: ReactNode
	iconBgColor: string
	iconColor: string
	label: string
	title: string
	aside?: ReactNode
}

export const DashboardCardHeader = ({
	icon,
	iconBgColor,
	iconColor,
	label,
	title,
	aside
}: DashboardCardHeaderProps) => (
	<div className="flex items-center justify-between gap-3 border-b border-border px-4 py-4 sm:px-5">
		<div className="flex min-w-0 items-center gap-3">
			<IconWrapper iconBgColor={iconBgColor} iconColor={iconColor}>
				{icon}
			</IconWrapper>
			<div className="min-w-0">
				<p className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
					{label}
				</p>
				<h2 className="truncate font-display text-[17px] font-semibold">{title}</h2>
			</div>
		</div>
		{aside}
	</div>
)
